import React from 'react'
import {observer} from 'mobx-react-lite'
import {Typography, Accordion, AccordionSummary, AccordionDetails, Grid, Box} from '@mui/material'
import {ExpandIcon} from '@oc/icons'
import {OcGenericStatusComponentProps} from './OcGenericStatusInterfaces'
import {makeOcStyles} from '@oc/styles'

const useStyles = makeOcStyles(theme => ({
    accordion: {
        width: '100%',
        border: `1px solid ${theme.syskronPalette.colors.S500}`,
        minWidth: '600px'
    },
    accordionDetails: {
        flexDirection: 'column',
        padding: 0
    },
    accordionDetailItem: {
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(4),
        paddingLeft: theme.spacing(6),
        paddingBottom: theme.spacing(1)
    },
    accordionSummary: {
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        padding: 0
    },
    summary: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        paddingRight: theme.spacing(4)
    },
    statusText: {
        paddingLeft: theme.spacing(1)
    },
    statusTextBold: {
        fontWeight: 'bold',
        paddingLeft: theme.spacing(1)
    },
    label: {
        fontWeight: 'bold',
        paddingRight: theme.spacing(1),
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    },
    text: {
        display: 'flex',
        alignItems: 'center',
        width: '80%'
    },
    iconStatus: {
        display: 'flex',
        alignItems: 'center',
        width: '20%'
    },
    marginZero: {
        margin: '0 !important'
    },
    expandIcon: {
        marginRight: 0
    }
}))

function _OcGenericStatusComponent(props: OcGenericStatusComponentProps) {
    const {steps} = props
    const {classes} = useStyles()
    const [expandedPanelIndex, setExpandedPanelIndex] = React.useState(-1)
    const expandPanel = React.useCallback(
        (index: number) => {
            setExpandedPanelIndex(index === expandedPanelIndex ? -1 : index)
        },
        [expandedPanelIndex]
    )

    return (
        <Grid>
            {steps.map((process, index) => (
                <Accordion
                    key={index}
                    className={classes.accordion}
                    expanded={expandedPanelIndex === index}
                    onChange={() => expandPanel(index)}
                    classes={{expanded: classes.marginZero}}
                >
                    <AccordionSummary
                        className={classes.accordionSummary}
                        expandIcon={<ExpandIcon />}
                        id={`process-${index}`}
                        classes={{expandIconWrapper: classes.expandIcon}}
                    >
                        <Box className={classes.summary}>
                            <Box className={classes.text}>
                                {process.icon}
                                <Typography className={classes.label}>{process.label}</Typography>
                                {process.optionalLabel && <Typography>({process.optionalLabel})</Typography>}
                            </Box>
                            <Box className={classes.iconStatus}>
                                {process.status.icon}
                                <Typography className={classes.statusTextBold}>{process.status.text}</Typography>
                            </Box>
                        </Box>
                    </AccordionSummary>

                    <AccordionDetails className={classes.accordionDetails}>
                        {process.steps.map((step, index) => (
                            <Box className={classes.accordionDetailItem} key={index}>
                                <Box className={classes.text}>
                                    {step.icon}
                                    <Typography>{step.description}</Typography>
                                </Box>
                                <Box className={classes.iconStatus}>
                                    {step.status.icon}
                                    <Typography className={classes.statusText}>{step.status.text}</Typography>
                                </Box>
                            </Box>
                        ))}
                    </AccordionDetails>
                </Accordion>
            ))}
        </Grid>
    )
}

export const OcGenericStatusComponent = observer(_OcGenericStatusComponent)
